module.exports = __webpack_public_path__ + "img/ics_o_services.e594205b.svg";